import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

/** RU */
const ru = {
  company: 'АСТОРИУС',
  subtitle: 'Агентство премиальной недвижимости',
  pickObject: 'Обратная связь',
  favorites: 'Избранное',
  whatsapp: 'WhatsApp',
  callWord: 'Телефон',

  learnMore: 'Узнать детали у эксперта',
  common: {
    learnMore: 'Узнать детали у эксперта',
    name: 'Имя',
    phone: 'Телефон',
    email: 'E-mail',
    comment: 'Комментарий',
    loading: 'Загрузка…',
    nothingFound: 'Ничего не найдено',
    prev: 'Назад',
    next: 'Вперёд',
    pageOf: 'Стр. {{p}} из {{n}}',
    objectN: 'Объект {{n}}',          // ← для дефолтных названий карточек
  },

  // меню
  newbuild: 'Новостройки',
  commercial: 'Коммерческая',
  secondary: 'Вторичная',
  rent: 'Аренда',
  districts: 'Районы',
  services: 'Услуги',
  blog: 'Блог',
  media: 'СМИ',
  news: 'Новости',
  corporation: 'О нас',

  // главная страница
  home: {
    servicesTitle: 'Наши услуги',
    mediaTitle: 'СМИ о нас',
    newsTitle: 'Новости',
    blogTitle: 'Блог',
    awardsTitle: 'Награды',
    reviewsTitle: 'Отзывы',
    contactTitle: 'Свяжитесь с нами',
    weekly: 'Рекомендуем',
    invest: 'Инвестиционная недвижимость',
    collections: 'Подборки',
    districts: 'Районы',
    listings: 'Объекты',
    authorsTitle: 'Авторские каталоги',
    authorsSubtitle: 'Актуальные PDF-каталоги',
    collectionsGridTitle: 'Все подборки',
    about: 'О компании',
    leadership: 'Руководство',
    chairmanTitle: 'Обращение руководства',
    chairmanPresident: 'Обращение президента',
    chairmanChairman: 'Обращение председателя',
    presidentQuote: 'Добро пожаловать в Astorius — место, где сделки с элитной недвижимостью становятся искусством, а каждая история — историей доверия.',
    chairmanQuote: 'Мы действуем исключительно в интересах клиента: прозрачные процессы, безупречный сервис и внимание к деталям — наш стандарт.',
    quickTitle: 'Быстрая консультация',
  },

  objectCard: {
    loading: 'Загрузка…',
    notFound: 'Объект не найден',
    backToCatalog: 'Вернуться в каталог',
    onSale: 'В продаже',
    installments: 'Рассрочка',
    investment: 'Инвестиционный',
    featured: 'Рекомендуемый',
    bedroomsFrom: 'Комнаты от',
    bedroomsTo: 'до',
    bedrooms: 'Комнаты',
    areaFrom: 'Площадь от',
    areaTo: 'до',
    area: 'Площадь',
    priceFrom: 'Стоимость от',
    location: 'Локация',
    addToFavorites: 'Добавить в избранное',
    inFavorites: 'В избранном',
    developer: 'Застройщик',
    telegram: 'Telegram',
    requestCall: 'Перезвоните мне',
    loadingManagers: 'Загрузка менеджеров…',
    propertyExpert: 'Эксперт по недвижимости',
    units: 'Планировки',
    paymentPlans: 'Условия оплаты',
    stage: 'Этап',
    noStages: 'Этапы не указаны.',
    description: 'Описание',
    projectDescription: 'Описание проекта',
    currentStatus: 'Статус',
    propertyInfo: 'Информация об объекте',
    dealType: 'Тип сделки',
    propertyType: 'Тип объекта',
    bathrooms: 'Санузлы',
    address: 'Адрес',
    price: 'Цена',
    pricePerM2: 'Цена за м²',
    upTo: 'до',
    visualizations: 'Визуализации',
    amenities: 'Удобства',
    amenitiesNotSpecified: 'Информация об удобствах не указана',
    amenity: 'Удобство',
    locationSection: 'Расположение',
    locationNotAvailable: 'Координаты местоположения недоступны',
    nearbyLocations: {
      restaurants: 'Рестораны и кафе',
      shops: 'Магазины и торговля',
      infrastructure: 'Инфраструктура',
    },
  },

  nav: {
    realty: 'Недвижимость',
    newbuilds: 'Новостройки',
    commercial: 'Коммерческая',
    secondary: 'Вторичная',
    foreign: 'Зарубежная',
    suburban: 'Загородная',
    commercialRent: 'Коммерческая аренда',
    mansions: 'Особняки',
    parking: 'Паркинги',
    rent: 'Аренда',
    districts: 'Районы',
    services: 'Услуги',
    blog: 'Блог',
    media: 'СМИ',
    news: 'Новости',
    corporation: 'О нас',
  },

  header: {
    corporation: 'О НАС',
    servicesMenu: {
      sellOrRent: 'Продать или сдать',
      invest: 'Инвестиционная',
      law: 'Консалтинг и Право',
      design: 'Дизайн и Ремонт',
      analytics: 'Управление и Аналитика',
      about: 'О нас',
    },
  },

  contacts: {
    title: 'Контакты',
    contactInfo: 'Контактная информация',
    phone: 'Телефон',
    email: 'Электронная почта',
    address: 'Адрес',
    addressValue: 'Москва, ул. Бахрушина, д. 23 стр. 1',
    workingHours: 'Режим работы',
    monday: 'Понедельник',
    tuesday: 'Вторник',
    wednesday: 'Среда',
    thursday: 'Четверг',
    friday: 'Пятница',
    saturday: 'Суббота',
    sunday: 'Воскресенье',
    mondayFriday: 'Понедельник - Пятница',
    closed: 'Выходной',
  },

  /* Домашняя */
  collections: {
    title: 'Подборки объектов',
    subtitle: 'Готовые наборы для быстрого выбора',
    all: 'Все подборки',
    viewAll: 'Смотреть всё',
    defaultTitle: 'Объекты',
    objectsCount: 'Объектов: {{n}}',
  },

  /* Каталог */
  catalog: {
    title: 'Каталог объектов',
    labels: { 
      unit: 'Юнит', 
      area: 'Площадь', 
      price: 'Стоимость', 
      city: 'Город', 
      handover: 'Готовность',
      district: 'Район',
      installment: 'Рассрочка',
      priceFrom: 'Стоимость от',
      areaFrom: 'Площадь от',
      priceOnRequest: 'Цена по запросу'
    },
  },

  /* Страницы услуг */
  servicesPage: {
    title: 'Услуги',
    groups: {
      sellOrRent: 'Продать или сдать',
      invest: 'Инвестиционная недвижимость',
      law: 'Консалтинг и право',
      design: 'Дизайн и ремонт',
      analytics: 'Управление и аналитика',
    },
    descriptions: {
      sellOrRent: 'Комплексные услуги по продаже и сдаче в аренду элитной недвижимости с полным сопровождением.',
      invest: 'Подбор инвестиционных проектов, моделирование доходности, сопровождение сделки.',
      law: 'Правовой аудит объектов, договоры, сопровождение сделок, налоговое и миграционное консультирование.',
      design: 'Дизайн-проект, комплектация, ремонт и авторский надзор. Поворачиваем ключи — и можно жить.',
      analytics: 'Оценка рентабельности, стратегии владения, управление арендой, отчетность и аналитика рынка.',
    },
  },

  // Контентные
  blogPage: { title: 'Блог', read: 'Читать' },
  
  blogPost: {
    readingTime: 'мин чтения',
    views: 'просмотров',
    tableOfContents: 'Содержание',
    share: 'Поделиться статьей',
    shareOn: 'Поделиться в',
    telegram: 'Telegram',
    whatsapp: 'WhatsApp',
    vk: 'ВКонтакте',
    consultation: {
      title: 'Нужна консультация?',
      text: 'Наши эксперты помогут вам с выбором недвижимости',
      button: 'Получить консультацию'
    },
    newsletter: {
      title: 'Подпишитесь на нашу рассылку',
      text: 'Получайте последние новости о недвижимости и эксклюзивные предложения',
      placeholder: 'Ваш email',
      button: 'Подписаться',
      success: 'Спасибо за подписку!'
    },
    tags: 'Теги',
    related: 'Похожие статьи',
    readAlso: 'Читайте также',
    viewAll: 'Все статьи блога',
    navigation: {
      prev: 'Предыдущая статья',
      next: 'Следующая статья'
    },
    lightbox: {
      close: 'Закрыть',
      prev: 'Предыдущее изображение',
      next: 'Следующее изображение',
      counter: '{{current}} из {{total}}'
    }
  },

  socialmediaPage: { title: 'СМИ', more: 'Все статьи' },
  newsPage: { title: 'Новости', more: 'Все новости' },

  // (удалили дубликат top-level "blog": { title: ... })

  // карточки/лейблы
  card: {
    district: 'Район',
    layouts: 'Планировки',
    installment: 'Рассрочка',
    months_short: 'мес.',
    studio: 'Студия',
    area_m2: 'м²',
    price_from: 'Стоимость от',
    details: 'Подробнее',
  },

  /* Юниты */
  units: {
    title: 'Типовые планировки и цены',
    labels: {
      bedrooms: 'Спальни',
      areaFrom: 'Площадь от',
      priceFrom: 'Стоимость от',
    },
    status: {
      available: 'Свободен',
      reserved: 'Забронирован',
      sold: 'Продан',
    },
    filters: {
      bedroomsShort: 'спальн.',
      roomsAny: 'Любые спальни',
      statusAny: 'Любой статус',
      minPrice: 'Мин. цена',
      maxPrice: 'Макс. цена',
      featuredAny: 'Рекомендуемость',
      featuredYes: 'Рекомендуемые',
      featuredNo: 'Обычные',
      apply: 'Показать',
      reset: 'Сбросить',
      showMore: 'Показать ещё',
    },
    sort: {
      newest: 'Сначала новые',
      priceAsc: 'Цена ↑',
      priceDesc: 'Цена ↓',
      areaAsc: 'Площадь ↑',
      areaDesc: 'Площадь ↓',
    },
  },

  // корпорация
  corporation: {
    title: 'Корпорация АСТОРИУС',
    subtitle: 'Ведущая корпорация в сфере премиальной недвижимости',
  },

  // квиз/попап
  quiz: {
    title: 'Пройти опрос',
    lead: 'Подберём лучшие варианты по вашему запросу, включая закрытые лоты!',
    notice: 'Подберем лучшие варианты по Вашему запросу, включая закрытые лоты!',
    stepLabel: 'Квиз: шаг {{n}}',
    next: 'Далее',
    prev: 'Назад',
    finish: 'Отправить',
    thanks: 'Спасибо! Мы свяжемся с вами в ближайшее время.',
    fields: { name:'Имя', phone:'Телефон', email:'E-mail', budget:'Бюджет', city:'Город/локация', type:'Тип недвижимости', comment:'Комментарий' },
    openCta: 'Заказать проект',
    modalTitle: 'Заказать проект',
    modalLead: 'Оставьте контакты и мы свяжемся с вами для обсуждения деталей проекта',
    placeholders: { name:'Имя', phone:'+7 (999) 999-99-99', email:'you@email.com', comment:'Комментарий…' },
    send: 'Заказать',
    okMsg: 'Спасибо! Заявка отправлена, свяжемся в ближайшее время.',
    invalid: 'Укажите имя и телефон в формате +7XXXXXXXXXX',
  },

  contactForm: {
    name: 'Имя',
    phone: 'Телефон',
    email: 'E-mail',
    message: 'Комментарий',
    send: 'Отправить',
    ok: 'Заявка отправлена, свяжемся в ближайшее время.',
    errorNamePhone: 'Укажите имя и телефон в формате +7XXXXXXXXXX',
  },


  /* Банер категорий на главной */
  categoryBanner: {
    title: 'Наши услуги и направления',
    secondary: 'Вторичные объекты',
    rent: 'Аренда квартир',
    commercial: 'Коммерческая недвижимость',
    commercialRent: 'Аренда коммерческой недвижимости',
    mansions: 'Особняки и усадьбы',
    foreign: 'Зарубежная недвижимость',
    sell: 'Продадим недвижимость',
    rentService: 'Сдадим в аренду',
  },

  /* Поисковик на главной */
  search: {
    title: 'Найти недвижимость',
    propertyType: 'Тип недвижимости',
    dealType: 'Тип сделки',
    district: 'Район',
    bedrooms: 'Количество комнат',
    price: 'Цена',
    area: 'Площадь, м²',
    any: 'Любой',
    anyBedrooms: 'Любое',
    from: 'от',
    to: 'до',
    onMap: 'На карте',
    find: 'Найти',
  },

  /* Фильтры */
  filters: {
    propertyType: 'Тип недвижимости',
    variant: 'Вариант',
    district: 'Район',
    rooms: 'Комнат',
    pricePerM2: 'Цена за м²',
    priceTotal: 'Стоимость объекта',
    area: 'Площадь, м²',
    from: 'от',
    to: 'до',
    any: 'Любой',
    map: 'На карте',
    find: 'Найти',
  },

  footer: {
    company: 'АСТОРИУС',
    slogan: 'Агентство премиальной недвижимости',
    pickObject: 'Подобрать объект',
    sellProperty: 'Продать недвижимость',
    map: 'Поиск на карте',
    newbuilds: 'Новостройки',
    secondary: 'Вторичная',
    rent: 'Аренда',
    contacts: 'Контакты',
    about: 'О нас',
    media: 'СМИ',
    blog: 'Блог',
    vacancies: 'Вакансии',
    privacy: 'Политика конфиденциальности',
    rights: '© 2025 АСТОРИУС. Все права защищены.',
  },

  mobileMenu: {
    weeklyRecommendations: 'Рекомендации недели',
    bestInstallments: 'Лучшие рассрочки',
    caoHouses: 'Дома в ЦАО',
    waterfrontHouses: 'Дома у воды',
    authorCatalogs: 'Авторские каталоги недвижимости',
    reviews: 'Отзывы',
    awards: 'Премии и награды',
    promotions: 'Акции',
    partners: 'Партнерские программы',
    admin: 'Управление',
    mission: 'Миссия',
    values: 'Корпоративные ценности',
    directions: 'Направления деятельности',
    culture: 'Корпоративная культура',
    theme: 'Тема',
  },

  contactModal: {
    title: 'Продать недвижимость',
    name: 'Имя',
    nameRequired: 'Имя *',
    namePlaceholder: 'Ваше имя',
    phone: 'Телефон',
    phoneRequired: 'Телефон *',
    phonePlaceholder: '+7 (999) 999-99-99',
    email: 'Email',
    emailPlaceholder: 'your@email.com',
    message: 'Сообщение',
    messagePlaceholder: 'Расскажите о вашей недвижимости: тип, район, площадь, желаемая цена...',
    submit: 'Отправить заявку',
    submitting: 'Отправляем...',
    thankYou: 'Спасибо!',
    successMessage: 'Ваша заявка отправлена. Мы свяжемся с вами в ближайшее время.',
  },

  cookieConsent: {
    message: 'Мы используем файлы cookie для улучшения работы сайта и анализа трафика. Продолжая использовать сайт, вы соглашаетесь с нашей',
    privacyPolicy: 'Политикой конфиденциальности',
    accept: 'Принять',
    decline: 'Отклонить',
  },

  partner: {
    subtitle: 'Партнёр компании АСТОРИУС',
    verified: 'Проверенный партнёр',
    notFound: 'Партнёр не найден',
  },

  /* Админка */
  admin: {
    title: 'Админ-панель',
    tabs: { properties: 'Объекты', leads: 'Лиды', media: 'Медиа', currencies: 'Курс валют' },
    common: { create: 'Создать', save: 'Сохранить', cancel: 'Отмена', logout: 'Выйти', actions: 'Действия', edit:'Ред.', delete:'Удалить', yes:'Да', no:'Нет', none:'—' },
    login: {
      title: 'Вход в админ-панель',
      username: 'Логин',
      password: 'Пароль',
      signIn: 'Войти',
      error: 'Неверный логин или пароль',
      devHint: 'Для dev-режима: логин {{u}}, пароль {{p}}',
    },
    properties: {
      create:'Создать объект', edit:'Редактировать объект', list:'Список объектов',
      title:'Название', slug:'Слаг', priceAED:'Цена (AED)', city:'Город',
      region:'Регион', district:'Район',
      propTypeId:'Тип объекта (ID)', propTypeHint:'Напр.: 1 — квартира, 2 — апартаменты…',
      dealTypeId:'Тип сделки (ID)', dealTypeHint:'Напр.: 1 — покупка, 2 — аренда…',
      bedrooms:'Спальни', area:'Площадь, м²',
      handoverQ:'Сдача (квартал)', handoverY:'Сдача (год)',
      installment:'Рассрочка', tags:'Теги', featured:'Рекомендуемое', invest:'Инвест',
      cover:'Обложка (URL)', coverHint:'Можно загрузить файл ниже — URL подставится автоматически.',
      upload:'Загрузка изображения', extra:'Доп. поля (JSON)',
      deleteConfirm:'Удалить объект?', extraInvalid:'Некорректный JSON в доп. полях',
    },
    leads: { title:'Лиды', type:'Тип', name:'Имя', phone:'Телефон', status:'Статус', pin:'Закрепить', unpin:'Открепить' },
    media: { title:'Загрузка медиа', uploaded:'Загружено:' },
    currencies: { title:'Курсы валют (относительно AED)', updated:'Курсы обновлены' },
  },

  regionsList: ['Москва','Московская область','Санкт-Петербург','Сочи','Крым','ОАЭ'],
  cityMap: {
    'Москва': 'Moscow',
    'Московская область': 'Moscow Region',
    'Санкт-Петербург': 'Saint Petersburg',
    'Сочи': 'Sochi',
    'Крым': 'Crimea',
    'Дубай': 'Dubai',
    'ОАЭ': 'UAE',
  },

  regions: {
    allRegions: 'Все регионы',
    selectRegion: 'Выберите регион',
    personalizeMessage: 'Мы персонализируем объекты и контент под выбранный регион.',
    moscow: 'Москва',
    moscowRegion: 'Московская область',
    stPetersburg: 'Санкт-Петербург',
    sochi: 'Сочи',
    crimea: 'Крым',
    uae: 'ОАЭ',
    dubai: 'Дубай',
  },
};

/** EN */
const en = {
  company: 'ASTORIUS',
  subtitle: 'Premium Real Estate Agency',
  pickObject: 'Contact us',
  favorites: 'Favorites',
  whatsapp: 'WhatsApp',
  callWord: 'Phone',

  learnMore: 'Ask an expert',
  common: {
    learnMore: 'Ask an expert',
    name: 'Name',
    phone: 'Phone',
    email: 'E-mail',
    comment: 'Comment',
    loading: 'Loading…',
    nothingFound: 'Nothing found',
    prev: 'Back',
    next: 'Next',
    pageOf: 'Page {{p}} of {{n}}',
    objectN: 'Object {{n}}',         // ← for default card names
  },

  newbuild: 'New builds',
  commercial: 'Commercial',
  secondary: 'Secondary',
  rent: 'Rent',
  districts: 'Districts',
  services: 'Services',
  blog: 'Blog',
  media: 'Media',
  news: 'News',
  corporation: 'Astorius Corporation',

  // home page
  home: {
    servicesTitle: 'Our Services',
    mediaTitle: 'Media about us',
    newsTitle: 'News',
    blogTitle: 'Blog',
    awardsTitle: 'Awards',
    reviewsTitle: 'Reviews',
    contactTitle: 'Contact us',
    weekly: 'Recommended',
    invest: 'Investment properties',
    collections: 'Collections',
    districts: 'Districts',
    listings: 'Properties',
    authorsTitle: 'Author catalogs',
    authorsSubtitle: 'Current PDF catalogs',
    collectionsGridTitle: 'All collections',
    about: 'About company',
    leadership: 'Leadership',
    bannerTitle: 'We will sell or rent out your property',
    bannerCta: 'Send request',
    partners: 'Partners',
    collectionsTitle: 'Selections',
    collectionsSubtitle: 'Curated sets for quick choice',
    collectionsAll: 'All selections',
    collectionsViewAll: 'View all',
    chairmanTitle: 'Message from the Board',
    chairmanPresident: 'Message from the President',
    chairmanChairman: 'Message from the Chairman',
    presidentQuote:
      'Welcome to Astorius — a place where prime real-estate deals become art and every story is a story of trust.',
    chairmanQuote:
      'We act solely in the client s best interest: transparent processes, impeccable service, and attention to detail are our standard.',
    quickTitle: 'Quick consultation',
  },

  objectCard: {
    loading: 'Loading…',
    notFound: 'Property not found',
    backToCatalog: 'Back to catalog',
    onSale: 'On sale',
    installments: 'Installments',
    investment: 'Investment',
    featured: 'Featured',
    bedroomsFrom: 'Bedrooms from',
    bedroomsTo: 'to',
    bedrooms: 'Bedrooms',
    areaFrom: 'Area from',
    areaTo: 'to',
    area: 'Area',
    priceFrom: 'Price from',
    location: 'Location',
    addToFavorites: 'Add to favorites',
    inFavorites: 'In favorites',
    developer: 'Developer',
    telegram: 'Telegram',
    requestCall: 'Request a call',
    loadingManagers: 'Loading managers…',
    propertyExpert: 'Property expert',
    units: 'Floor plans',
    paymentPlans: 'Payment plans',
    stage: 'Stage',
    noStages: 'No stages provided.',
    description: 'Description',
    projectDescription: 'Project description',
    currentStatus: 'Current status',
    propertyInfo: 'Information about the property',
    dealType: 'Deal type',
    propertyType: 'Property type',
    bathrooms: 'Bathrooms',
    address: 'Address',
    price: 'Price',
    pricePerM2: 'Price per m²',
    upTo: 'up to',
    visualizations: 'Visualizations',
    amenities: 'Amenities',
    amenitiesNotSpecified: 'Amenities information not specified',
    amenity: 'Amenity',
    locationSection: 'Location',
    locationNotAvailable: 'Location coordinates not available',
    nearbyLocations: {
      restaurants: 'Restaurants & Cafes',
      shops: 'Shopping & Retail',
      infrastructure: 'Infrastructure',
    },
  },

  nav: {
    realty: 'Real estate',
    newbuilds: 'New builds',
    commercial: 'Commercial',
    secondary: 'Secondary',
    foreign: 'Foreign',
    suburban: 'Suburban',
    commercialRent: 'Commercial rent',
    mansions: 'Mansions',
    parking: 'Parking',
    rent: 'Rent',
    districts: 'Districts',
    services: 'Services',
    blog: 'Blog',
    media: 'Media',
    news: 'News',
    corporation: 'Astorius Corporation',
  },

  header: {
    corporation: 'ASTORIUS CORPORATION',
    servicesMenu: {
      sellOrRent: 'Sell or rent',
      invest: 'Investment',
      law: 'Consulting & Legal',
      design: 'Design & Fit-out',
      analytics: 'Management & Analytics',
      about: 'About us',
    },
  },

  contacts: {
    title: 'Contacts',
    contactInfo: 'Contact Information',
    phone: 'Phone',
    email: 'Email',
    address: 'Address',
    addressValue: 'Moscow, Bakhrushina str., 23 bld. 1',
    workingHours: 'Working Hours',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
    mondayFriday: 'Monday - Friday',
    closed: 'Closed',
  },

  catalog: {
    labels: {
      installment: 'Installment',
      area: 'Area',
      areaFrom: 'from',
      priceFrom: 'from',
      handover: 'Handover',
      priceOnRequest: 'Price on request'
    },
  },

  /* Pages catalogs */
  pages: {
    foreign: {
      description: 'Exclusive premium real estate properties in the world\'s best locations. Investments in stable markets with high growth potential.',
    },
    suburban: {
      description: 'Elite cottages, townhouses and land plots in prestigious settlements of Moscow region and other areas.',
    },
    commercialRent: {
      description: 'Offices, retail spaces, warehouses and industrial premises in the best business locations with high traffic.',
    },
    mansions: {
      description: 'Luxury mansions and premium residences with unique architecture and exclusive amenities.',
    },
    parking: {
      description: 'Parking spaces in underground and ground-level garages of elite residential complexes and business centers in the city center.',
    },
  },

  collections: {
    title: 'Property Collections',
    subtitle: 'Curated sets for quick choice',
    all: 'All selections',
    viewAll: 'View all',
    defaultTitle: 'Objects',
    objectsCount: 'Objects: {{n}}',
  },

  catalog: {
    title: 'Property catalog',
    labels: { 
      unit: 'Unit', 
      area: 'Area', 
      price: 'Price', 
      city: 'City', 
      handover: 'Handover',
      district: 'District',
      installment: 'Installment',
      priceFrom: 'Price from',
      areaFrom: 'Area from'
    },
  },

  servicesPage: {
    title: 'Services',
    groups: {
      sellOrRent: 'Sell or rent',
      invest: 'Investment real estate',
      law: 'Consulting & legal',
      design: 'Design & fit-out',
      analytics: 'Management & analytics',
    },
    descriptions: {
      sellOrRent: 'Comprehensive services for selling and renting premium real estate with full support.',
      invest: 'Selection of investment projects, yield modeling, deal support.',
      law: 'Legal due diligence, contracts, deal support, tax & migration advisory.',
      design: 'Interior design, procurement, renovation, author supervision. Turn-key delivery.',
      analytics: 'Yield assessment, holding strategies, rental management, reporting and market analytics.',
    },
  },

  blogPage: { title: 'Blog', read: 'Read' },
  
  blogPost: {
    readingTime: 'min read',
    views: 'views',
    tableOfContents: 'Table of Contents',
    share: 'Share article',
    shareOn: 'Share on',
    telegram: 'Telegram',
    whatsapp: 'WhatsApp',
    vk: 'VKontakte',
    consultation: {
      title: 'Need consultation?',
      text: 'Our experts will help you choose the right property',
      button: 'Get consultation'
    },
    newsletter: {
      title: 'Subscribe to our newsletter',
      text: 'Get the latest real estate news and exclusive offers',
      placeholder: 'Your email',
      button: 'Subscribe',
      success: 'Thank you for subscribing!'
    },
    tags: 'Tags',
    related: 'Related articles',
    readAlso: 'Read also',
    viewAll: 'All blog articles',
    navigation: {
      prev: 'Previous article',
      next: 'Next article'
    },
    lightbox: {
      close: 'Close',
      prev: 'Previous image',
      next: 'Next image',
      counter: '{{current}} of {{total}}'
    }
  },
  socialmediaPage: { title: 'Media about us', more: 'All articles' },
  newsPage: { title: 'News', more: 'All news' },

  // (removed duplicate top-level "blog": { title: ... })

  card: {
    district: 'District',
    layouts: 'Layouts',
    installment: 'Installments',
    months_short: 'mo',
    studio: 'Studio',
    area_m2: 'm²',
    price_from: 'Price from',
    details: 'Details',
  },

  /* Units */
  units: {
    title: 'Typical units & prices',
    labels: {
      bedrooms: 'Bedrooms',
      areaFrom: 'Area from',
      priceFrom: 'Price from',
    },
    status: {
      available: 'Available',
      reserved: 'Reserved',
      sold: 'Sold',
    },
    filters: {
      bedroomsShort: 'bed',
      roomsAny: 'Any bedrooms',
      statusAny: 'Any status',
      minPrice: 'Min price',
      maxPrice: 'Max price',
      featuredAny: 'Featured',
      featuredYes: 'Featured only',
      featuredNo: 'Not featured',
      apply: 'Apply',
      reset: 'Reset',
      showMore: 'Show more',
    },
    sort: {
      newest: 'Newest',
      priceAsc: 'Price ↑',
      priceDesc: 'Price ↓',
      areaAsc: 'Area ↑',
      areaDesc: 'Area ↓',
    },
  },

  corporation: {
    title: 'ASTORIUS Corporation',
    subtitle: 'Leading corporation in premium real estate',
  },

  quiz: {
    title: 'Take the quiz',
    lead: 'We’ll select the best options for your request, including off-market lots!',
    notice: 'We\'ll pick the best options for your request, including off-market lots!',
    stepLabel: 'Quiz: step {{n}}',
    next: 'Next',
    prev: 'Back',
    finish: 'Submit',
    thanks: 'Thanks! We will contact you shortly.',
    fields: { name:'Name', phone:'Phone', email:'E-mail', budget:'Budget', city:'City/area', type:'Property type', comment:'Comment' },
    openCta: 'Order a project',
    modalTitle: 'Order a project',
    modalLead: 'Leave your contacts and we will get back to you to discuss details.',
    placeholders: { name:'Name', phone:'+7 (999) 999-99-99', email:'you@email.com', comment:'Comment…' },
    send: 'Order',
    okMsg: 'Thank you! We will contact you shortly.',
    invalid: 'Enter name and phone in +7XXXXXXXXXX format',
  },

  contactForm: {
    name: 'Name',
    phone: 'Phone',
    email: 'E-mail',
    message: 'Comment',
    send: 'Send',
    ok: 'Request sent. We will contact you shortly.',
    errorNamePhone: 'Enter name and phone in +7XXXXXXXXXX format',
  },


  /* Category banner on home */
  categoryBanner: {
    title: 'Our services and directions',
    secondary: 'Secondary properties',
    rent: 'Apartment rental',
    commercial: 'Commercial real estate',
    commercialRent: 'Commercial rental',
    mansions: 'Mansions & estates',
    foreign: 'Foreign real estate',
    sell: 'Sell property',
    rentService: 'Rent out property',
  },

  /* Search widget on home */
  search: {
    title: 'Find property',
    propertyType: 'Property type',
    dealType: 'Deal type',
    district: 'District',
    bedrooms: 'Number of bedrooms',
    price: 'Price',
    area: 'Area, m²',
    any: 'Any',
    anyBedrooms: 'Any',
    from: 'from',
    to: 'to',
    onMap: 'On map',
    find: 'Find',
  },

  filters: {
    propertyType: 'Property type',
    variant: 'Variant',
    district: 'District',
    rooms: 'Bedrooms',
    pricePerM2: 'Price per m²',
    priceTotal: 'Price total',
    area: 'Area, m²',
    from: 'from',
    to: 'to',
    any: 'Any',
    map: 'Map',
    find: 'Find',
  },

  footer: {
    company: 'ASTORIUS',
    slogan: 'Premium Real Estate Agency',
    pickObject: 'Find property',
    sellProperty: 'Sell property',
    map: 'Map search',
    newbuilds: 'New builds',
    secondary: 'Secondary',
    rent: 'Rent',
    contacts: 'Contacts',
    about: 'About',
    media: 'Media',
    blog: 'Blog',
    vacancies: 'Vacancies',
    privacy: 'Privacy policy',
    rights: '© 2025 ASTORIUS. All rights reserved.',
  },

  mobileMenu: {
    weeklyRecommendations: 'Weekly recommendations',
    bestInstallments: 'Best installments',
    caoHouses: 'Houses in CAO',
    waterfrontHouses: 'Waterfront houses',
    authorCatalogs: 'Author catalogs',
    reviews: 'Reviews',
    awards: 'Awards',
    promotions: 'Promotions',
    partners: 'Partner programs',
    admin: 'Management',
    mission: 'Mission',
    values: 'Corporate values',
    directions: 'Business directions',
    culture: 'Corporate culture',
    theme: 'Theme',
  },

  contactModal: {
    title: 'Sell property',
    name: 'Name',
    nameRequired: 'Name *',
    namePlaceholder: 'Your name',
    phone: 'Phone',
    phoneRequired: 'Phone *',
    phonePlaceholder: '+7 (999) 999-99-99',
    email: 'Email',
    emailPlaceholder: 'your@email.com',
    message: 'Message',
    messagePlaceholder: 'Tell us about your property: type, district, area, desired price...',
    submit: 'Submit request',
    submitting: 'Submitting...',
    thankYou: 'Thank you!',
    successMessage: 'Your request has been submitted. We will contact you shortly.',
  },

  cookieConsent: {
    message: 'We use cookies to improve the website and analyze traffic. By continuing to use the site, you agree to our',
    privacyPolicy: 'Privacy Policy',
    accept: 'Accept',
    decline: 'Decline',
  },

  partner: {
    subtitle: 'ASTORIUS Partner',
    verified: 'Verified Partner',
    notFound: 'Partner not found',
  },

  admin: {
    title: 'Admin panel',
    tabs: { properties:'Properties', leads:'Leads', media:'Media', currencies:'Currencies' },
    common: { create:'Create', save:'Save', cancel:'Cancel', logout:'Log out', actions:'Actions', edit:'Edit', delete:'Delete', yes:'Yes', no:'No', none:'—' },
    login: {
      title: 'Admin login',
      username: 'Username',
      password: 'Password',
      signIn: 'Sign in',
      error: 'Wrong username or password',
      devHint: 'Dev login: {{u}} / {{p}}',
    },
    properties: {
      create:'Create property', edit:'Edit property', list:'Property list',
      title:'Title', slug:'Slug', priceAED:'Price (AED)', city:'City',
      region:'Region', district:'District',
      propTypeId:'Property type (ID)', propTypeHint:'E.g. 1 — apartment, 2 — serviced apt…',
      dealTypeId:'Deal type (ID)', dealTypeHint:'E.g. 1 — buy, 2 — rent…',
      bedrooms:'Bedrooms', area:'Area, m²',
      handoverQ:'Handover (quarter)', handoverY:'Handover (year)',
      installments:'Installments', tags:'Tags', featured:'Featured', invest:'Investment',
      cover:'Cover (URL)', coverHint:'You can upload a file below — URL will fill automatically.',
      upload:'Upload image', extra:'Extra fields (JSON)',
      deleteConfirm:'Delete property?', extraInvalid:'Invalid JSON in extra fields',
    },
    leads: { title:'Leads', type:'Type', name:'Name', phone:'Phone', status:'Status', pin:'Pin', unpin:'Unpin' },
    media: { title:'Media upload', uploaded:'Uploaded:' },
    currencies: { title:'Currency rates (vs AED)', updated:'Rates updated' },
  },

  regionsList: ['Moscow','Moscow Region','Saint Petersburg','Sochi','Crimea','UAE'],
  cityMap: {
    'Moscow': 'Москва',
    'Moscow Region': 'Московская область',
    'Saint Petersburg': 'Санкт-Петербург',
    'Sochi': 'Сочи',
    'Crimea': 'Крым',
    'Dubai': 'Дубай',
    'UAE': 'ОАЭ',
  },

  regions: {
    allRegions: 'All regions',
    selectRegion: 'Select region',
    personalizeMessage: 'We\'ll personalize listings and content for your region.',
    moscow: 'Moscow',
    moscowRegion: 'Moscow Region',
    stPetersburg: 'Saint Petersburg',
    sochi: 'Sochi',
    crimea: 'Crimea',
    uae: 'UAE',
    dubai: 'Dubai',
  },
};

/** ZH (Chinese) */
const zh = {
  company: 'ASTORIUS',
  subtitle: '高端房地产中介',
  pickObject: '联系我们',
  favorites: '收藏夹',
  whatsapp: 'WhatsApp',
  callWord: '电话',

  learnMore: '咨询专家',
  common: {
    learnMore: '咨询专家',
    name: '姓名',
    phone: '电话',
    email: '电子邮件',
    comment: '评论',
    loading: '加载中…',
    nothingFound: '未找到',
    prev: '返回',
    next: '下一步',
    pageOf: '第 {{p}} 页，共 {{n}} 页',
    objectN: '物业 {{n}}',
  },

  newbuild: '新建项目',
  commercial: '商业地产',
  secondary: '二手房',
  rent: '租赁',
  districts: '地区',
  services: '服务',
  blog: '博客',
  media: '媒体',
  news: '新闻',
  corporation: '关于我们',

  home: {
    servicesTitle: '我们的服务',
    mediaTitle: '媒体报道',
    newsTitle: '新闻',
    blogTitle: '博客',
    awardsTitle: '奖项',
    reviewsTitle: '评价',
    contactTitle: '联系我们',
    weekly: '推荐',
    invest: '投资房产',
    collections: '精选',
    districts: '地区',
    listings: '房产',
    authorsTitle: '精选目录',
    authorsSubtitle: '最新PDF目录',
    collectionsGridTitle: '所有精选',
    about: '关于公司',
    leadership: '领导团队',
    bannerTitle: '我们将出售或出租您的房产',
    bannerCta: '提交申请',
    partners: '合作伙伴',
    collectionsTitle: '精选',
    collectionsSubtitle: '快速选择的精选集',
    collectionsAll: '所有精选',
    collectionsViewAll: '查看全部',
    chairmanTitle: '领导致辞',
    chairmanPresident: '总裁致辞',
    chairmanChairman: '董事长致辞',
    presidentQuote: '欢迎来到ASTORIUS——在这里，高端房地产交易成为艺术，每个故事都是信任的故事。',
    chairmanQuote: '我们完全以客户利益为重：透明的流程、无可挑剔的服务和对细节的关注是我们的标准。',
    quickTitle: '快速咨询',
  },

  objectCard: {
    loading: '加载中…',
    notFound: '未找到房产',
    backToCatalog: '返回目录',
    onSale: '在售',
    installments: '分期付款',
    investment: '投资',
    featured: '推荐',
    bedroomsFrom: '卧室从',
    bedroomsTo: '到',
    bedrooms: '卧室',
    areaFrom: '面积从',
    areaTo: '到',
    area: '面积',
    priceFrom: '价格从',
    location: '位置',
    addToFavorites: '添加到收藏夹',
    inFavorites: '已收藏',
    developer: '开发商',
    telegram: 'Telegram',
    requestCall: '请求回电',
    loadingManagers: '加载经理中…',
    propertyExpert: '房产专家',
    units: '户型图',
    paymentPlans: '付款计划',
    stage: '阶段',
    noStages: '未提供阶段。',
    description: '描述',
    projectDescription: '项目描述',
    currentStatus: '当前状态',
    propertyInfo: '房产信息',
    dealType: '交易类型',
    propertyType: '房产类型',
    bathrooms: '浴室',
    address: '地址',
    price: '价格',
    pricePerM2: '每平方米价格',
    upTo: '最高',
    visualizations: '效果图',
    amenities: '设施',
    amenitiesNotSpecified: '未指定设施信息',
    amenity: '设施',
    locationSection: '位置',
    locationNotAvailable: '位置坐标不可用',
    nearbyLocations: {
      restaurants: '餐厅和咖啡馆',
      shops: '购物和零售',
      infrastructure: '基础设施',
    },
  },

  nav: {
    realty: '房地产',
    newbuilds: '新建项目',
    commercial: '商业地产',
    secondary: '二手房',
    foreign: '海外房产',
    suburban: '郊区房产',
    commercialRent: '商业租赁',
    mansions: '豪宅',
    parking: '停车位',
    rent: '租赁',
    districts: '地区',
    services: '服务',
    blog: '博客',
    media: '媒体',
    news: '新闻',
    corporation: '关于我们',
  },

  header: {
    corporation: '关于我们',
    servicesMenu: {
      sellOrRent: '出售或出租',
      invest: '投资',
      law: '咨询与法律',
      design: '设计与装修',
      analytics: '管理与分析',
      about: '关于我们',
    },
  },

  contacts: {
    title: '联系方式',
    contactInfo: '联系信息',
    phone: '电话',
    email: '电子邮件',
    address: '地址',
    addressValue: '莫斯科，巴赫鲁申娜街，23号1栋',
    workingHours: '工作时间',
    monday: '星期一',
    tuesday: '星期二',
    wednesday: '星期三',
    thursday: '星期四',
    friday: '星期五',
    saturday: '星期六',
    sunday: '星期日',
    mondayFriday: '星期一 - 星期五',
    closed: '休息',
    mapTitle: '我们的位置',
    mapSubtitle: '将加载交互式地图',
  },

  catalog: {
    title: '房产目录',
    labels: {
      installment: '分期付款',
      area: '面积',
      areaFrom: '起',
      priceFrom: '起',
      handover: '交付',
      unit: '单元',
      price: '价格',
      city: '城市',
      district: '地区',
      priceOnRequest: '价格面议'
    },
  },

  pages: {
    foreign: {
      description: '世界最佳地点的独家高端房产。投资于具有高增长潜力的稳定市场。',
    },
    suburban: {
      description: '莫斯科地区和其他地区著名定居点的精英别墅、联排别墅和土地。',
    },
    commercialRent: {
      description: '最佳商业地点的办公室、零售空间、仓库和工业场所，人流量大。',
    },
    mansions: {
      description: '具有独特建筑和专属设施的豪华豪宅和高端住宅。',
    },
    parking: {
      description: '市中心精英住宅区和商务中心地下和地面车库的停车位。',
    },
  },

  collections: {
    title: '精选',
    subtitle: '快速选择的精选集',
    all: '所有精选',
    viewAll: '查看全部',
    defaultTitle: '房产',
    objectsCount: '房产数：{{n}}',
  },

  servicesPage: {
    title: '服务',
    groups: {
      sellOrRent: '出售或出租',
      invest: '投资房地产',
      law: '咨询与法律',
      design: '设计与装修',
      analytics: '管理与分析',
    },
    descriptions: {
      sellOrRent: '全面的高端房地产销售和租赁服务，提供全程支持。',
      invest: '投资项目选择、收益建模、交易支持。',
      law: '法律尽职调查、合同、交易支持、税务和移民咨询。',
      design: '室内设计、采购、装修、作者监督。交钥匙交付。',
      analytics: '收益评估、持有策略、租赁管理、报告和市场分析。',
    },
  },

  blogPage: { title: '博客', read: '阅读' },
  
  blogPost: {
    readingTime: '分钟阅读',
    views: '浏览',
    tableOfContents: '目录',
    share: '分享文章',
    shareOn: '分享到',
    telegram: 'Telegram',
    whatsapp: 'WhatsApp',
    vk: 'VKontakte',
    consultation: {
      title: '需要咨询？',
      text: '我们的专家将帮助您选择合适的房产',
      button: '获取咨询'
    },
    newsletter: {
      title: '订阅我们的新闻',
      text: '获取最新的房地产新闻和独家优惠',
      placeholder: '您的电子邮件',
      button: '订阅',
      success: '感谢订阅！'
    },
    tags: '标签',
    related: '相关文章',
    readAlso: '另请阅读',
    viewAll: '所有博客文章',
    navigation: {
      prev: '上一篇文章',
      next: '下一篇文章'
    },
    lightbox: {
      close: '关闭',
      prev: '上一张图片',
      next: '下一张图片',
      counter: '{{current}} / {{total}}'
    }
  },

  socialmediaPage: { title: '媒体报道', more: '所有文章' },
  newsPage: { title: '新闻', more: '所有新闻' },

  card: {
    district: '地区',
    layouts: '布局',
    installment: '分期付款',
    months_short: '月',
    studio: '单间',
    area_m2: '平方米',
    price_from: '价格起',
    details: '详情',
  },

  units: {
    title: '典型单元和价格',
    labels: {
      bedrooms: '卧室',
      areaFrom: '面积起',
      priceFrom: '价格起',
    },
    status: {
      available: '可用',
      reserved: '已预订',
      sold: '已售',
    },
    filters: {
      bedroomsShort: '卧室',
      roomsAny: '任意卧室',
      statusAny: '任意状态',
      minPrice: '最低价格',
      maxPrice: '最高价格',
      featuredAny: '推荐',
      featuredYes: '仅推荐',
      featuredNo: '非推荐',
      apply: '应用',
      reset: '重置',
      showMore: '显示更多',
    },
    sort: {
      newest: '最新',
      priceAsc: '价格 ↑',
      priceDesc: '价格 ↓',
      areaAsc: '面积 ↑',
      areaDesc: '面积 ↓',
    },
  },

  corporation: {
    title: 'ASTORIUS公司',
    subtitle: '高端房地产领先公司',
  },

  quiz: {
    title: '参加问卷',
    lead: '我们将为您的请求选择最佳选项，包括场外交易！',
    notice: '我们将为您的请求选择最佳选项，包括场外交易！',
    stepLabel: '问卷：第 {{n}} 步',
    next: '下一步',
    prev: '返回',
    finish: '提交',
    thanks: '谢谢！我们会尽快与您联系。',
    fields: { name:'姓名', phone:'电话', email:'电子邮件', budget:'预算', city:'城市/地区', type:'房产类型', comment:'评论' },
    openCta: '订购项目',
    modalTitle: '订购项目',
    modalLead: '留下您的联系方式，我们将与您联系讨论详情。',
    placeholders: { name:'姓名', phone:'+7 (999) 999-99-99', email:'you@email.com', comment:'评论…' },
    send: '订购',
    okMsg: '谢谢！我们会尽快与您联系。',
    invalid: '请输入姓名和电话，格式为 +7XXXXXXXXXX',
  },

  contactForm: {
    name: '姓名',
    phone: '电话',
    email: '电子邮件',
    message: '评论',
    send: '发送',
    ok: '申请已发送。我们会尽快与您联系。',
    errorNamePhone: '请输入姓名和电话，格式为 +7XXXXXXXXXX',
  },

  categoryBanner: {
    title: '我们的服务和方向',
    secondary: '二手房',
    rent: '公寓租赁',
    commercial: '商业地产',
    commercialRent: '商业租赁',
    mansions: '豪宅和庄园',
    foreign: '海外房产',
    sell: '出售房产',
    rentService: '出租房产',
  },

  search: {
    title: '查找房产',
    propertyType: '房产类型',
    dealType: '交易类型',
    district: '地区',
    bedrooms: '卧室数量',
    price: '价格',
    area: '面积，平方米',
    any: '任意',
    anyBedrooms: '任意',
    from: '从',
    to: '到',
    onMap: '在地图上',
    find: '查找',
  },

  filters: {
    propertyType: '房产类型',
    variant: '变体',
    district: '地区',
    rooms: '卧室',
    pricePerM2: '每平方米价格',
    priceTotal: '总价',
    area: '面积，平方米',
    from: '从',
    to: '到',
    any: '任意',
    map: '地图',
    find: '查找',
  },

  footer: {
    company: 'ASTORIUS',
    slogan: '高端房地产中介',
    pickObject: '选择房产',
    sellProperty: '出售房产',
    map: '地图搜索',
    newbuilds: '新建项目',
    secondary: '二手房',
    rent: '租赁',
    contacts: '联系方式',
    about: '关于我们',
    media: '媒体',
    blog: '博客',
    vacancies: '职位',
    privacy: '隐私政策',
    rights: '© 2025 ASTORIUS。保留所有权利。',
  },

  mobileMenu: {
    weeklyRecommendations: '每周推荐',
    bestInstallments: '最佳分期付款',
    caoHouses: 'CAO地区房屋',
    waterfrontHouses: '滨水房屋',
    authorCatalogs: '精选目录',
    reviews: '评价',
    awards: '奖项',
    promotions: '促销',
    partners: '合作伙伴计划',
    admin: '管理',
    mission: '使命',
    values: '企业价值观',
    directions: '业务方向',
    culture: '企业文化',
    theme: '主题',
  },

  contactModal: {
    title: '出售房产',
    name: '姓名',
    nameRequired: '姓名 *',
    namePlaceholder: '您的姓名',
    phone: '电话',
    phoneRequired: '电话 *',
    phonePlaceholder: '+7 (999) 999-99-99',
    email: '电子邮件',
    emailPlaceholder: 'your@email.com',
    message: '留言',
    messagePlaceholder: '告诉我们您的房产信息：类型、区域、面积、期望价格...',
    submit: '提交申请',
    submitting: '提交中...',
    thankYou: '谢谢！',
    successMessage: '您的申请已提交。我们会尽快与您联系。',
  },

  cookieConsent: {
    message: '我们使用cookies来改善网站并分析流量。继续使用网站即表示您同意我们的',
    privacyPolicy: '隐私政策',
    accept: '接受',
    decline: '拒绝',
  },

  partner: {
    subtitle: 'ASTORIUS合作伙伴',
    verified: '认证合作伙伴',
    notFound: '未找到合作伙伴',
  },

  admin: {
    title: '管理面板',
    tabs: { properties:'房产', leads:'潜在客户', media:'媒体', currencies:'货币' },
    common: { create:'创建', save:'保存', cancel:'取消', logout:'退出', actions:'操作', edit:'编辑', delete:'删除', yes:'是', no:'否', none:'—' },
    login: {
      title: '管理员登录',
      username: '用户名',
      password: '密码',
      signIn: '登录',
      error: '用户名或密码错误',
      devHint: '开发登录：{{u}} / {{p}}',
    },
    properties: {
      create:'创建房产', edit:'编辑房产', list:'房产列表',
      title:'标题', slug:'Slug', priceAED:'价格 (AED)', city:'城市',
      region:'地区', district:'区域',
      propTypeId:'房产类型 (ID)', propTypeHint:'例如：1 — 公寓，2 — 服务式公寓…',
      dealTypeId:'交易类型 (ID)', dealTypeHint:'例如：1 — 购买，2 — 租赁…',
      bedrooms:'卧室', area:'面积，平方米',
      handoverQ:'交付（季度）', handoverY:'交付（年份）',
      installments:'分期付款', tags:'标签', featured:'推荐', invest:'投资',
      cover:'封面 (URL)', coverHint:'您可以在下面上传文件 — URL将自动填充。',
      upload:'上传图片', extra:'额外字段 (JSON)',
      deleteConfirm:'删除房产？', extraInvalid:'额外字段中的JSON无效',
    },
    leads: { title:'潜在客户', type:'类型', name:'姓名', phone:'电话', status:'状态', pin:'固定', unpin:'取消固定' },
    media: { title:'媒体上传', uploaded:'已上传：' },
    currencies: { title:'货币汇率（相对于AED）', updated:'汇率已更新' },
  },

  regionsList: ['莫斯科','莫斯科州','圣彼得堡','索契','克里米亚','阿联酋'],
  cityMap: {
    '莫斯科': 'Moscow',
    '莫斯科州': 'Moscow Region',
    '圣彼得堡': 'Saint Petersburg',
    '索契': 'Sochi',
    '克里米亚': 'Crimea',
    '迪拜': 'Dubai',
    '阿联酋': 'UAE',
  },

  regions: {
    allRegions: '所有地区',
    selectRegion: '选择地区',
    personalizeMessage: '我们将为您的地区个性化房源和内容。',
    moscow: '莫斯科',
    moscowRegion: '莫斯科州',
    stPetersburg: '圣彼得堡',
    sochi: '索契',
    crimea: '克里米亚',
    uae: '阿联酋',
    dubai: '迪拜',
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources: { 
      ru: { translation: ru }, 
      en: { translation: en },
      zh: { translation: zh }
    },
    lng: localStorage.getItem('lang') || 'ru',
    fallbackLng: 'ru',
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });

if (typeof document !== 'undefined') {
  document.documentElement.lang = i18n.language || 'ru';
  i18n.on('languageChanged', (lng) => {
    document.documentElement.lang = lng || 'ru';
    localStorage.setItem('lang', lng || 'ru');
  });
}

export default i18n;
